var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('WidgetsDropdown',{attrs:{"payable":_vm.payable,"sales":_vm.salesQty,"buys":_vm.purchaseQty,"products":_vm.productQty,"customers":_vm.customerQty}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }